export enum Environment {
  Production = 'Production',
  Staging = 'Staging',
}

export interface IConfig {
  environment: Environment;
  apiUrl: string;
}

interface ConfigObject {
  Production: IConfig;
  Staging: IConfig;
}

export const env: Environment = Environment.Production;

const envs: ConfigObject = {
  Production: {
    environment: Environment.Production,
    apiUrl: 'https://crypto-pay-service.cryptosrvc.com',
  },
  Staging: {
    environment: Environment.Staging,
    apiUrl: 'https://crypto-pay-service.cryptosrvc-staging.com',
  },
};

export default envs[env];
